module.exports = __webpack_public_path__ + "static/media/seven.6d1880ee.jpg";